


















































































import { Component, Prop, Vue, Emit, PropSync } from "vue-property-decorator";
import { Page } from "@/interfaces/page";

@Component
export default class Paginator extends Vue {
    @PropSync("pages") pagesProp!: Page[];

    @Prop() public pageIndex!: number;

    @Emit() public click(event: { index: number }) {
        return event;
    }

    @Emit() public add() {
        return;
    }

    @Emit() public remove(event: { index: number }) {
        return event;
    }

    public move(oldIndex: number, newIndex: number) {
        if (newIndex >= this.pagesProp.length) {
            newIndex = this.pagesProp.length - 1;
        }
        this.pagesProp.splice(
            newIndex,
            0,
            this.pagesProp.splice(oldIndex, 1)[0]
        );
        this.click({ index: newIndex });
    }

    public get canAdd() {
        return !!this.$listeners && !!this.$listeners.add;
    }

    public get canRemove() {
        return !!this.$listeners && !!this.$listeners.remove;
    }
}
